import React from 'react'
import AllOrderPeykContainer from '../../../../Components/OrdersPeykPart/AllOrderPeykContainer/AllOrderPeykContainer'
import Layout from '../../Layout'

const AllOrderPeyk = () => {
  return (
    <Layout>
      <AllOrderPeykContainer/>
    </Layout>
  )
}

export default AllOrderPeyk